var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"c-a-icon"},[_c('use',{attrs:{"href":("/assets/icons/icons.svg#" + _vm.icon),"xlink:href":("/assets/icons/icons.svg#" + _vm.icon)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9fb3e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/atoms/AtomIcon.vue
// module id = 929
// module chunks = 0